<template>
  <t-default-entry sub-heading="Login" heading="初回ログイン" :class="componentClassName">
    <div v-if="error" class="t-login-invited-user-sms__alert">
      <a-alert :title="errorMessage" color="error" size="small" />
    </div>
    <form class="t-login-invited-user-sms__form" @submit.prevent="handleFormSubmit">
      <div class="t-login-invited-user-sms__group">
        <div class="t-login-invited-user-sms__instruction">
          <a-heading tag="h4">SMS認証</a-heading>
          <a-text v-if="!isOTPSent">
            電話番号を入力し、下のボタンをタップすると、お客様のSMSに認証コードが送られます。
          </a-text>
          <a-text v-if="isOTPSent">
            「{{ phoneNumber }}」宛にSMSを送信いたしました。メッセージ内に記載されたコードを入力してください。
          </a-text>
        </div>
        <m-form-input v-if="!isOTPSent" class="t-login-invited-user-sms__input" label="電話番号">
          <a-text-field v-model="formData.phone_number" type="number" placeholder="0312345678" />
          <template #note>
            <a-caption-list>
              <li>通信料はお客さまのご負担となります。</li>
            </a-caption-list>
          </template>
        </m-form-input>
        <m-form-input v-if="isOTPSent" class="t-login-invited-user-sms__input" label="6桁の認証コード">
          <a-text-field v-model="formData.otp" type="number" placeholder="123456" />
          <template #note>
            <a-caption-list>
              <li>
                認証が失敗する場合は
                <a-button variant="text" color="primary" target="_blank" :href="authFailUrl">こちら</a-button>
              </li>
            </a-caption-list>
          </template>
        </m-form-input>
      </div>
      <m-button-container class="t-login-invited-user-sms__buttons">
        <a-button v-if="!isOTPSent" variant="block" color="primary" @click="handleSendOTPClick">
          SMSに認証コードを送る
        </a-button>
        <template v-if="isOTPSent">
          <a-button variant="block" submit="submit" color="primary">次へ</a-button>
          <a-button variant="outlined" color="primary" @click="handleSendOTPClick"> 認証コードを再送する </a-button>
        </template>
        <a-button color="primary" class="t-invited-user-sms__button-optional" @click="handleCancelClick">戻る</a-button>
      </m-button-container>
    </form>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AAlert from '@/components/atoms/alert';
import AButton from '@/components/atoms/button';
import ACaptionList from '@/components/atoms/caption-list';
import ATextField from '@/components/atoms/text-field';
import MButtonContainer from '@/components/molecules/button-container';
import MFormInput from '@/components/molecules/form-input';
import TDefaultEntry from '@/components/templates/default-entry';
import AHeading from '@/components/atoms/heading';
import AText from '@/components/atoms/text';
import { cloneDeep } from 'lodash';

export default {
  name: 't-login-invited-user-sms',
  components: {
    AAlert,
    AButton,
    ACaptionList,
    ATextField,
    MButtonContainer,
    MFormInput,
    TDefaultEntry,
    AHeading,
    AText,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    isOTPSent: {
      type: Boolean,
      default: false,
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    authFailUrl: {
      type: String,
      default: '#',
    },
    handleSendVerificationCodeClick: {
      type: Function,
      default: () => {},
    },
    handleSubmitForm: {
      type: Function,
      default: () => {},
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        phone_number: '',
        otp: '',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-login-invited-user-sms');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleSendOTPClick() {
      const formData = cloneDeep(this.formData);
      const payload = {
        phone_number: this.isOTPSent ? this.phoneNumber : formData.phone_number,
      };
      this.handleSendVerificationCodeClick(payload);
    },
    handleFormSubmit(event) {
      event.preventDefault();
      const formData = cloneDeep(this.formData);
      const payload = {
        otp: formData.otp,
      };
      this.handleSubmitForm(payload);
    },
  },
};
</script>
